import { DateMath } from "../../../../library-js/date/DateMath";
import { Duration } from "../../../../library-js/date/Duration";
import { TextSorter } from "../../../../library-js/dom-actions/filter-and-sort/sorters/TextSorter";
import { ClassFlag } from "../../../../library-js/dom-tools/ClassFlag";
import { ElementAttribute } from "../../../../library-js/dom-tools/ElementAttribute";
import { ElementType } from "../../../../library-js/dom-tools/ElementType";
import { OnChange, OnClick } from "../../../../library-js/dom-tools/EventListeners";
import { DOMOrientation } from "../../../../library-js/dom/DOMOrientation";
import { SortText } from "../../../../library-js/text/SortText";
import { ISOTimeStamp } from "../../../../library/ts/vanilla/time/ISOTimeStamp";
import { LocalIO } from "../../../js/_internal/LocalIO";
import { StreamerEntry, PageStreamerEntry } from "./StreamerEntry";
import { StreamerIndex } from "./StreamerIndex";
import { StreamerPage } from "./StreamerPage";
import { JSRandomEngine } from "../../../../library-js/random/JSRandomEngine";
import { Arrays } from "../../../../library-js/tools/Arrays";
import { sleep } from "../../../../library-js/tools/sleep";
import { HTMLEditor } from "../../../../library-js/dom-tools/HTMLEditor";
import { CSV } from "../../../../library/ts/vanilla/text/CSV";
export class StreamerDB
{
  static readonly path      = "C:/rokojori/projects/rokojori-marketing/streamers/twitch-tracker/German/";

  static readonly indexPath = StreamerDB.path + "index.json";
  static readonly cacheDirectoryPath = StreamerDB.path + "cache/";
  static readonly sheetsPath = StreamerDB.path + "sheets.csv";

  static readonly streamerEntry = new ElementType( "streamer-entry" );
  static readonly streamerList  = new ElementType( "streamer-list" );
  static readonly streamerValue = new ElementType( "streamer-value" );
  static readonly numStreamers = new ElementType( "num-streamers" );

  static readonly textFilter = new ElementAttribute( "text-filter" );
  static readonly export = new ElementAttribute( "export" );

  static readonly sorting = new ElementAttribute( "sorting" );
  static readonly exclude = new ElementAttribute( "exclude" );
  static readonly filter = new ElementAttribute( "filter" );
  static readonly reverseSorting = new ElementAttribute( "reverse-sorting" );  
  
  _element:HTMLElement;
  _pages:StreamerPage[] = [];
  _streamers:StreamerEntry[] = null;
  _useIndex = true;
  _saveIndexAtStart = false;
  
  _streamersWithoutEmail:StreamerEntry[] = [] 
  _streamersWithEmail:StreamerEntry[] = [];
  
  
  async initialize( e:Element )
  {
    this._element = e as HTMLElement;

    if ( ! this._useIndex )
    {
      await this._loadFromData();   
    }
    else
    {
      await this._loadIndex();
    }

    let now = new Date();

    this._streamers.forEach(
      ( s )=>
      {
        if ( s.emailCandidates && s.emailCandidates.length !== 0 )
        {
          this._streamersWithEmail.push( s );
          return;
        }
        
        let checkTime = s.emailCheckTime;

        if ( ! checkTime )
        {
          this._streamersWithoutEmail.push( s );
          return;
        } 

        let checkedTime = ISOTimeStamp.toDate( checkTime );
        let elapsedMS = DateMath.getDifferenceMs( now, checkedTime ); 
        let elapsed =  Duration.milliSecondsToSeconds( elapsedMS );
        let elapsedHours = Duration.secondsToHours( elapsed );

        if ( elapsedHours > 24 )
        {
          this._streamersWithoutEmail.push (s );
        }

      }
    )
    
    OnChange.add( StreamerDB.sorting.query( this._element ) as HTMLElement, ()=> this.updateList() );
    OnChange.add( StreamerDB.filter.query( this._element ) as HTMLElement, ()=> this.updateList() );
    OnChange.add( StreamerDB.exclude.query( this._element ) as HTMLElement, ()=> this.updateList() );
    OnChange.add( StreamerDB.textFilter.query( this._element ) as HTMLElement, ()=> this.updateList() );
    OnChange.add( StreamerDB.reverseSorting.query( this._element ) as HTMLElement, ()=> this.updateList() );

    OnClick.add( StreamerDB.export.query( this._element ), 
      async ( e ) =>
      {
        console.log( "Exporting:", this._visibleStreamers.length ); 
        let csv = CSV.with( StreamerEntry.createCSVHeader() );

        this._visibleStreamers.forEach(
          ( s )=>
          {
            csv.appendLine( StreamerEntry.getCSVLine( s ) );
          }
        );

        await LocalIO.saveCSV( StreamerDB.sheetsPath, csv );

        console.log( "Exported to:", StreamerDB.sheetsPath ); 

      } 
    );

    this.updateList();

    if ( this._saveIndexAtStart )
    {
      await this._saveIndex();  
    }

    console.log( "With Email:", this._streamersWithEmail.length );
    //let streamer = this._streamers.find( s => s.twitchHandle === "nils" );

    // await this.getEmailFor( streamer );

    // this.loadEmails();

    /// this.loadEmailsFromCache();
  }   

  async loadEmailsForUnassigned()
  {
    let random = JSRandomEngine.$;

    while ( this._streamersWithoutEmail.length > 0 )
    {
      let se = random.from( this._streamersWithoutEmail );
      Arrays.remove( this._streamersWithoutEmail, se );

      await this.getEmailFor( se );

      let sleepTime = Math.random() * 2000 + 530;

      await sleep( sleepTime );
    }
  }

  async loadEmailsFromCache()
  {
    let index = 0;

    for ( let se of this._streamers )
    {
      let state = ( 100 * index / ( this._streamers.length - 1 ) ) ;
      console.log( "Progress:", state.toFixed( 2 ) + "%", ( index + 1 ) , "/", this._streamers.length );
      await this.getEmailFor( se, false );
      index++;      

      if ( index % 20 === 0 )
      {
        this.updateList();
      }
    }
    
    await this._saveIndex();
  }

  async getEmailFor( streamer:StreamerEntry, updateList = false )
  {
    console.log( "Getting email for:", streamer.twitchHandle );
    let emails = await StreamerEntry.scanForEmail( streamer );

    streamer.emailCandidates = emails;
    streamer.emailCheckTime = ISOTimeStamp.now();

    console.log( streamer.twitchHandle, ">>", emails.join( ", " ) );

    if ( updateList )
    {
      this.updateList();    
    }
    
  }

  async _loadFromData()
  {
    let numPages = 40;
    let fileName = "Twitch Top Streamers, June 2024, German · TwitchTracker.htm";

    for ( let i = 0; i < numPages; i++ )
    {
      let index = i + 1;
      let directoryPath = StreamerDB.path + `page ${index}/`;
      let filePath = directoryPath + fileName;
      
      //let text = await LocalIO.loadText( path );
      let doc = await LocalIO.loadDoc( filePath );
      console.log( "loading:", index, ">>", filePath );

      let page = new StreamerPage();
      page.process( doc, directoryPath );
      this._pages.push( page );
    }
  }

  async _loadIndex()
  {
    let streamerIndex = await LocalIO.loadJSON<StreamerIndex>( StreamerDB.indexPath );
    this._streamers = streamerIndex.streamers;

  }

  async _saveIndex()
  {
    let index = new StreamerIndex();
    index.streamers = this._streamers.map( s => StreamerEntry.createClone( s ) );

    await LocalIO.saveJSON( StreamerDB.indexPath, index );

  }

  isStreamerVisible( st:StreamerEntry )
  {   
    
    if ( st.exclude === true)
    {
      let removeExcluded = StreamerDB.exclude.query<HTMLInputElement>( this._element ).checked;

      if ( removeExcluded )
      {
        return false;
      }
    }

    let visible = this._isStreamerVisible(st );

    if ( ! visible )
    {
      return false;
    }

    let textFilter = StreamerDB.textFilter.query<HTMLInputElement>( this._element );
    let filters = textFilter.value.split( ";" );


    for ( let i = 0; i < filters.length; i++ )
    {
      let isVisible = this._isVisibleByFilter( st, filters[ i ] );

      if ( ! isVisible )
      {
        return false;
      }
    }

    return true;
  } 


  _isVisibleByFilter( st:StreamerEntry, filter:string )
  {
    let followerRange = /followers:\s*(\d+)\s*\-\s*(\d+)/;

    if ( followerRange.test( filter ) )
    {
      return this._inRange( st, s => s.followers, filter, followerRange );
    }

    let viewersRange = /viewers:\s*(\d+)\s*\-\s*(\d+)/;

    if ( viewersRange.test( filter ) )
    {
      return this._inRange( st, s => s.viewers, filter, followerRange );
    }

    return true;
  }

  _inRange( st:StreamerEntry, getValue:(st:StreamerEntry)=>number, filter:string, regex:RegExp )
  {
    let result = regex.exec( filter );
    
    let min = parseInt( result[ 1 ] );
    let max = parseInt( result[ 2 ] );

    let value = getValue( st );

    return min <= value && value <= max;
  }

  _isStreamerVisible( st:StreamerEntry )
  {
    let filterType = StreamerDB.filter.query( this._element ) as HTMLSelectElement;

    if ( filterType.value === "All" )
    {
      return true;
    }

    let numEmails = StreamerEntry.getFilteredEmailCandidates( st.emailCandidates ).length;


    if ( filterType.value === "Without Email" )
    {
      return numEmails == 0;
    }
    else if ( filterType.value === "With Email" )
    {
      return numEmails >= 1;
    }
    else if ( filterType.value === "With Multiple Emails" )
    {
      return numEmails > 1;
    }

    return false;


  }

  _visibleStreamers:StreamerEntry[];

  updateList()
  {
    if ( this._streamers === null )
    {
      this._streamers = [];
      this._pages.forEach( p => this._streamers = this._streamers.concat( p._entries ) );
    }

    let list = StreamerDB.streamerList.query( this._element ) as HTMLElement;

    this.sort();
    list.innerHTML = "";

    let emailDomains = new Map<string,string[]>();

    let averageRateVF = 0;
    let averageRateVFCount = 0;

    let ratesMin = 1000;
    let ratesMax = 1000000;
    let rateBuckets = 20;
    let rateMaps:({value:number,count:number, followers:number, max:number, min:number})[] = [];

    for ( let i = 0; i < rateBuckets; i++ )
    {
      let state       = i / ( rateBuckets - 1 );
      let stateBefore = ( i - 1 )  / ( rateBuckets - 1 );

      let max = Math.round( ( ratesMax - ratesMin ) * state + ratesMin );
      let min = Math.round( ( ratesMax - ratesMin ) * stateBefore + ratesMin );

      min = Math.max( 0, min );

      let bucket = { value:0, count: 0, max:max, min:min, followers:0 };
      rateMaps.push( bucket );
    }

    this._streamers.forEach(
      ( st )=>
      {
        if ( st.viewersFollowersRatio < 10 )
        {
          averageRateVF += st.viewersFollowersRatio;
          averageRateVFCount++;

          let bucket = rateMaps.find( r => r.min <= st.followers && st.followers < r.max );

          if ( ! bucket )
          {
            bucket = st.followers < rateMaps[ 0 ].min ? rateMaps[ 0 ] : rateMaps[ rateMaps.length - 1 ]; 
          }

          
          bucket.value += st.viewersFollowersRatio;
          bucket.followers += st.followers / 10000;
          bucket.count += 1;
          
        }
        

        if ( ! st.emailCandidates ||st.emailCandidates.length === 0 )
        {
          return;
        }

        let email = st.emailCandidates[ 0 ];
        let domainRegex = /@(.+)$/;

        let result = domainRegex.exec( email );

        if ( ! result )
        {
          return;
        }

        let domain = result[ 1 ];

        if ( ! emailDomains.has( domain ) )
        {
          emailDomains.set( domain, [] );
        }

        let list =  emailDomains.get( domain );
        list.push( email );

      }
    )

    averageRateVF /= averageRateVFCount;

    

    let entries:{domain:string, emails:string[]}[] = [];

    for ( let vm of emailDomains )
    {
      let domain = vm[ 0 ];
      let emails = vm[ 1 ];

      if ( emails.length > 1 )
      {
        entries.push( { domain, emails  } );
      }

      
    }

    entries.sort( ( a, b ) => b.emails.length - a.emails.length );

    entries.forEach(
      ( e )=>
      {
        console.log( e.domain, ">>", e.emails.length, ">>\n", e.emails.join( ", " ));
      }
    );
      
    console.log( "AverageRate VF", averageRateVF );

    let infos = rateMaps.map(
      ( r )=>
      {
        let percentage = r.value/r.count;
        let rate = percentage / 100;
        let centerFollowers = ( r.followers / r.count ) * 10000;
        let centerViewers = Math.floor( centerFollowers * rate );
        let info = `[${r.min}-${r.max}]:${r.count} => ${centerViewers} avg viewers ( ${percentage.toFixed(2)}% )`;

        return info;
      }
    )

    console.log( infos.join( "\n" ) );

    this._visibleStreamers = this._streamers.filter( s => this.isStreamerVisible( s ) );
    this._visibleStreamers.forEach( 
      st => 
      StreamerEntry.createHTML( st, list, 
        async ()=>{ await this.updateList(); },
        async ()=>{ await this._saveIndex(); } 
      ) 
    );


    let numStreamers = StreamerDB.numStreamers.query( this._element );
    
    numStreamers.innerHTML = this._visibleStreamers.length + "";
  }

  sort()
  {
    let value = StreamerDB.sorting.query<HTMLSelectElement>( this._element ).value;

    let list = StreamerDB.streamerList.query( this._element ) 

    new ElementAttribute( "sorting" ).to( list, value );

    if ( "Name" === value )
    {
      SortText.sort( this._streamers, ( s ) => s.name.toLowerCase() );
    }
    else if ( "Rank" === value )
    {
      this._streamers.sort( ( a, b ) => a.rank - b.rank ) ;
    }
    else if ( "Followers" === value )
    {
      this._streamers.sort( ( a, b ) => a.followers - b.followers ) ;
    }
    else if ( "Viewers" === value )
    {
      this._streamers.sort( ( a, b ) => a.viewers - b.viewers ) ;
    }
    else if ( "Viewers-Followers-Ratio" === value )
    {
      this._streamers.sort( ( a, b ) => a.viewersFollowersRatio - b.viewersFollowersRatio ) ;
    }
    else if ( "Views" === value )
    {
      this._streamers.sort( ( a, b ) => StreamerEntry.safeViews( a ) - StreamerEntry.safeViews( b ) ) ;
    }

    let reverseElement = StreamerDB.reverseSorting.query<HTMLInputElement>( this._element )

    if ( reverseElement.checked )
    {
      this._streamers.reverse();
    }
    
  } 

  static parseToNumber( text:string )
  {
    text = text.trim();
    text = text.replace( /\,/, "" );

    let multiply = 1;

    if ( /K$/.test( text ) )
    {
      multiply = 1000;
      text = text.replace( /K$/, "" );
    }
    else if ( /M$/.test( text ) )
    {
      multiply = 1000 * 1000;
      text = text.replace( /M$/, "" );
    }
    

    let number = parseFloat( text );

    if ( isNaN( number ) )
    {
      return null;
    }

    return number * multiply;

  }
}